import { axiosObject } from "../accessServiceConfig";

export default function getUser() {
  return new Promise((resolve, reject) => {
    let uri = "/authorize";

    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
